module.exports = __webpack_public_path__ + "static/media/background-video-low.2f5fbb98.mp4";